import React from "react";
import { Button } from "reactstrap";

const PDFPagePrevNextButtons = ({ currentPage, numPages, setCurrentPage }) => {
    if (!numPages || numPages <= 1) return null;

    return (
        <div style={{ display: "flex", justifyContent: "center", gap: 20, marginBottom: 20 }}>
            <Button
                size="sm"
                disabled={currentPage <= 1}
                onClick={() => setCurrentPage(p => p - 1)}
            >
                Previous
            </Button>

            <input
                type="number"
                value={currentPage}
                min={1}
                max={numPages}
                onChange={(e) => {
                    let v = parseInt(e.target.value);
                    if (!v) return;
                    if (v < 1) v = 1;
                    if (v > numPages) v = numPages;
                    setCurrentPage(v);
                }}
                style={{
                    width: 70,
                    textAlign: "center",
                    fontWeight: 600,
                    fontSize: 14,
                    padding: "2px 6px",
                    borderRadius: 4,
                    border: "1px solid #ccc"
                }}
            />

            <div style={{ fontWeight: 600, fontSize: 14, paddingTop: 4 }}>
                / {numPages}
            </div>

            <Button
                size="sm"
                disabled={currentPage >= numPages}
                onClick={() => setCurrentPage(p => p + 1)}
            >
                Next
            </Button>
        </div>
    );
};

export default PDFPagePrevNextButtons;